import * as React from 'react';

function SvgSpeechBubbleReply(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 15" {...props}>
      <path
        stroke="#007BFF"
        strokeWidth={1.2}
        d="M9.317 14.4H1.085l2.355-2.089.41-.363-.324-.44A6.74 6.74 0 0 1 2.205 7.5C2.207 3.703 5.369.6 9.302.6S16.4 3.704 16.4 7.501c0 3.792-3.154 6.892-7.082 6.899Z"
      />
    </svg>
  );
}
export default SvgSpeechBubbleReply;
